import styled from 'styled-components';
import { fontFamily, breakpoints, colors, zIndex } from '../../ui/variables';

const main = {
  height: {
    iphone: 48,
  },
};

export const NotificationListStyle = styled.ul`
  z-index: 998;
  overflow-y: auto;
  overflow-x: none;
  position: fixed;
  right: -120%;
  top: ${main.height.iphone}px;
  height: 100%;
  max-height: calc(100vh - ${main.height.iphone}px);
  width: 100%;
  padding: 21px;
  border-top-left-radius: none;
  background-color: ${colors.veryDarkGrayishBlue};
  transition: 600ms right;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    height: 95%;
    width: 400px;
    border-top-left-radius: 13px;
  }

  &.opened {
    right: 0;
  }

  .notification-list-header {
    padding-left: 7px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    svg {
      margin-right: 10px;
    }
    .title-notification-list {
      ${fontFamily.sourceSansPro.bold}
    }
    .close-button {
      position: absolute;
      right: 0;
      top: 0;
      line-height: 1;
      transform: rotate(45deg);
      font-size: 30px;
      margin-right: 10px;
    }

    .bottom-close-button {
      position: fixed;
      width: 100%;
      bottom: 0;
      height: 47px;
      display: flex;
      justify-content: center;
      margin-left: -28px;
      background-color: ${colors.veryDarkGrayishBlue};
      ${fontFamily.sourceSansPro.bold}
      font-size: 14px;
      align-items: center;

      .close-button-symbol {
        position: absolute;
        line-height: 1;
        transform: rotate(45deg);
        font-size: 30px;
        margin-right: 15px;
        right: 0;
      }
    }
  }
`;
